import { ReactNode } from 'react';
import styled, { css } from 'styled-components';

import { H3 } from 'components/Text/H3';
import { Tile } from 'components/Tile/Tile';
import { TileBody } from 'components/Tile/TileBody';

const StyledTile = styled(Tile)`
  &[id] {
    scroll-margin-top: calc(83px + 36px);
  }

  margin-bottom: 36px;

  &:not(:first-child) {
    margin: 36px 0;
  }
`;
const StyledTileBody = styled(TileBody)`
  & > *:last-child {
    margin-bottom: 0;
  }
`;

const DescriptionVariants = {
  large: css`
    margin-block-end: 56px;
  `,
  compact: css`
    margin-block-end: 1em;
  `,
};

const Description = styled.div<{
  variant: keyof typeof DescriptionVariants | undefined;
}>`
  ${(props) => {
    if (!props.variant) return;
    return DescriptionVariants[props.variant];
  }}
`;

type Props = {
  id?: string;
  className?: string;
  title?: ReactNode;
  description?: ReactNode;
  children: ReactNode;
  large?: boolean;
  bodyPaddingBottom?: (string | number | null)[];
  compactDescription?: boolean;
};

export function FormSection({
  id,
  className,
  title,
  description,
  children,
  large,
  compactDescription,
  bodyPaddingBottom,
  ...props
}: Props) {
  let descriptionVariant: keyof typeof DescriptionVariants | undefined;
  if (large) descriptionVariant = 'large';
  if (compactDescription) descriptionVariant = 'compact';

  return (
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/jsx-props-no-spreading
    <StyledTile id={id} className={className} {...props}>
      <StyledTileBody
        p={large ? [48, null, 96] : [20, null, 40]}
        pt={large && [36, null, 64]}
        pb={bodyPaddingBottom}
      >
        {title && <H3 mb={large && !description ? 56 : undefined}>{title}</H3>}

        {description && (
          <Description variant={descriptionVariant}> {description}</Description>
        )}

        {children}
      </StyledTileBody>
    </StyledTile>
  );
}
